const BANNERS_PREFIX = '@@banners/';

export const BANNERS_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${BANNERS_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${BANNERS_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${BANNERS_PREFIX}FETCH_LIST_FAILURE`,
}

export const BANNERS_CONFIG = {
    DEFAULT_PAGE_SIZE: 10, 
}
